import { useMatch, Link } from "react-router-dom"
import t from "../service/translate.service";
import historyService from "../service/history.service";
import faqCategoryStore from "../store/admin/FaqCategory.store";
import { getOne } from '../store/offer.store'
import { useEffect, useState } from "react";
import { documents as documentFiles } from "../config";

const Breadcrumbs = () => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [loading, setLoading] = useState(true);
  const root = {
    label: t['HOME'],
    path: '/'
  }
  const tenantServicesRoot = [
    root,
    {
      label: t['TENANT_SERVICES'],
      path: '/tenant-services'
    }
  ]
  const contracts = [
    ...tenantServicesRoot,
    {
      label: t['CONTRACTS'],
      path: '/contracts'
    }
  ]
  const contractSign = [
    root,
    {
      label: t['CONTRACT_SIGN'],
      path: '/contract-sign'
    }
  ]
  const contractOverview = [
    ...contracts,
    {
      label: t['CONTRACT_OVERVIEW_TITLE'],
      path: '/contract-overview/:contractNumber',
      replaceParams: [
        'contractNumber'
      ]
    }
  ]
  const ocCalculations = [
    ...contractOverview,
    {
      label: t['OC_CALCULATION'],
      path: '/oc-calculations/:contractNumber',
      replaceParams: [
        'contractNumber'
      ]
    }
  ]
  const repairsAndInquiries = [
    ...tenantServicesRoot,
    {
      label: t['REPAIRS_AND_INQUIRIES'],
      path: '/repairs-and-inquiries'
    }
  ]
  const offers = [
    root,
    {
      label: t['OFFERS_TITLE'],
      path: '/offers'
    }
  ]
  const consultations = [
    ...tenantServicesRoot,
    {
      label: t['SCHEDULED_CONSULTATIONS_TITLE'],
      path: '/consultations',
    }
  ]
  const vouchers = [
    ...tenantServicesRoot,
    {
      label: t['VOUCHERS_TITLE'],
      path: '/vouchers',
    }
  ]
  const documents = [
    ...tenantServicesRoot,
    {
      label: t['DOCUMENTS'],
      path: '/documents',
    }
  ]
  const loyalty = [
    ...tenantServicesRoot,
    {
      label: t['LOYALTY_PROGRAM'],
      path: '/loyalty-program'
    }
  ]
  const rentContractDocuments = [
    ...contractOverview,
    {
      label: t['RENT_CONTRACT_DOCUMENTS'],
      path: 'rent-contract-documents/:contractNumber',
      replaceParams: [
        'contractNumber'
      ]
    }
  ]
  const receiptInspection = [
    ...tenantServicesRoot,
    {
      label: t['RECEIPT_INSPECTION'],
      path: '/receipt-inspection'
    }
  ]
  const routes = [
    {
      path: 'contracts',
      breadcrumbs: contracts
    },
    {
      path: 'contract-sign',
      breadcrumbs: contractSign
    },
    {
      path: 'contract-overview/:contractNumber',
      breadcrumbs: contractOverview
    },
    {
      path: 'oc-calculations/:contractNumber',
      breadcrumbs: ocCalculations
    },
    {
      path: 'oc-calculations/:contractNumber/preview/:docId',
      breadcrumbs: [
        ...ocCalculations,
        {
          label: t['PREVIEW'],
          path: ''
        }
      ]
    },
    {
      path: 'repairs-and-inquiries',
      breadcrumbs: repairsAndInquiries
    },
    {
      path: 'repairs-and-inquiries/new-request',
      breadcrumbs: [
        ...repairsAndInquiries,
        {
          label: t['NEW_REQUEST'],
          path: ''
        }
      ]
    },
    {
      path: 'repairs-and-inquiries/edit-request/:serviceRequestId',
      breadcrumbs: [
        ...repairsAndInquiries,
        {
          label: t['EDIT_REQUEST'],
          path: ''
        }
      ]
    },
    {
      path: 'offers',
      breadcrumbs: offers
    },
    {
      path: 'offer/:id',
      breadcrumbs: [
        ...offers,
        {
          label: async (params) => {
            const value = t['PREVIEW']
            try {
              const article = await getOne(params.id)
              return article.headline || value
            } catch (error) {
              return value
            }
          },
          path: '',
        }
      ]
    },
    {
      path: 'consultations',
      breadcrumbs: consultations
    },
    {
      path: 'consultations/:contractNumber/slots',
      breadcrumbs: [
        ...consultations,
        {
          label: t['SLOTS'],
          path: '',
        }
      ]
    },
    {
      path: 'vouchers',
      breadcrumbs: vouchers
    },
    {
      path: 'vouchers/:contractNumber/:fileName/preview',
      breadcrumbs: [
        ...vouchers,
        {
          label: t['PREVIEW'],
          path: '',
        }
      ]
    },
    {
      path: 'documents',
      breadcrumbs: documents
    },
    {
      path: 'documents/preview/:name',
      breadcrumbs: [
        ...documents,
        {
          label: t['PREVIEW'],
          path: '',
        }
      ]
    },
    {
      path: 'documents/sign/:name',
      breadcrumbs: [
        ...documents,
        {
          label: (params) => {
            const file = documentFiles.find((d) => d.fileName === params.name)
            return file ? file.label : t['FORM_EDIT']
          },
          path: '',
        }
      ]
    },
    {
      path: 'heating-and-energy',
      breadcrumbs: [
        ...tenantServicesRoot,
        {
          label: t['HEATING_AND_ENERGY_TITLE'],
          path: ''
        }
      ]
    },
    {
      path: 'faq/:id',
      breadcrumbs: [
        root,
        {
          label: t['MAIN_FAQ'],
          path: '/faq'
        },
        {
          label: async (params) => {
            const value = t['PREVIEW']
            try {
              const category = await faqCategoryStore.findOne(parseInt(params.id))
              return category.name || value
            } catch (error) {
              return value
            }
          },
          path: ''
        }
      ]
    },
    {
      path: 'loyalty-program',
      breadcrumbs: loyalty
    },
    {
      path: 'loyalty-program/faq',
      breadcrumbs: [
        ...loyalty,
        {
          label: t['MAIN_FAQ'],
          path: ''
        }
      ]
    },
    {
      path: 'contracts/prepayments/:contractNumber',
      breadcrumbs: [
        ...contractOverview,
        {
          label: t['OPERATING_COST_PREPAYMENT'],
          path: ''
        }
      ]
    },
    {
      path: 'contracts/add-contract',
      breadcrumbs: [
        ...contracts,
        {
          label: t['ADD_CONTRACT_BUTTON'],
          path: ''
        }
      ]
    },
    {
      path: 'letters',
      breadcrumbs: [
        ...tenantServicesRoot,
        {
          label: t['LETTERS_TITLE'],
          path: ''
        }
      ]
    },
    {
      path: 'rent-account/:contractNumber',
      breadcrumbs: [
        ...contractOverview,
        {
          label: t['RENT_ACCOUNT_BALANCE'],
          path: ''
        }
      ]
    },
    {
      path: 'rent-contract-documents/:contractNumber',
      breadcrumbs: rentContractDocuments
    },
    {
      path: 'rent-contract-documents/:contractNumber/:docId/preview',
      breadcrumbs: [
        ...rentContractDocuments,
        {
          label: t['PREVIEW'],
          path: ''
        }
      ]
    },
    {
      path: 'receipt-inspection',
      breadcrumbs: receiptInspection
    },
    {
      path: 'receipt-inspection/:contractNumber/:caseNumber/:year/:docName/:docId/preview',
      breadcrumbs: [
        ...receiptInspection,
        {
          label: t['PREVIEW'],
          path: ''
        }
      ]
    },
    {
      path: 'my-payment-details/:contractNumber',
      breadcrumbs: [
        ...contractOverview,
        {
          label: t['MY_PAYMENT_DETAILS'],
          path: ''
        }
      ]
    },
    {
      path: 'profile/theme',
      breadcrumbs: [
        {
          label: t['PROFILE'],
          path: '/profile'
        },
        {
          label: t['THEME_EDIT'],
          path: ''
        }
      ]
    }
  ]

  const getPathMatch = useMatch

  const match = routes
    .map((route) => ({
      ...route,
      useMatch: getPathMatch(route.path)
    }))
    .find((route) => route.useMatch);

  useEffect(() => {
    if (!match) return;

    let mounted = true;

    const getBreadcrumbs = async () => {
      const updatedBreadcrumbs = await Promise.all(
        match.breadcrumbs.map(async (crumb) => ({
          ...crumb,
          path: crumb.replaceParams
            ? crumb.replaceParams.reduce(
                (acc, param) => acc.replace(`:${param}`, match.useMatch.params[param]),
                crumb.path
              )
            : crumb.path,
          label: typeof crumb.label === 'function' ? await crumb.label(match.useMatch.params) : crumb.label,
        }))
      );

      if (mounted) {
        setBreadcrumbs(updatedBreadcrumbs);
        setLoading(false);
      }
    };

    getBreadcrumbs();

    return () => {
      mounted = false;
    };
  }, [match?.useMatch.params]);

  if (!match || loading) {
    return
  }

  return (
    <div className="breadcrumbs">{breadcrumbs.map((crumb, index) => {
      const lastItem = index === breadcrumbs.length - 1
      return (
        <span key={index} className="item">
          <span className="contain">{lastItem ? <span>{crumb.label}</span> : (
            <Link
              to={crumb.path}
              onClick={() => historyService.push(crumb.path)}
            >
              {crumb.label}
            </Link>
          )}</span>
          {!lastItem && '/'}
        </span>
      )
    })}
    </div>
  )
}

export default Breadcrumbs